import { Box, Button, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import NavbarLayout from '../../../common/NavbarLayout';
import { variants } from '../../../variants/variants';
import { Newspaper } from '@mui/icons-material';
import FileUpload from '../../../common/Utility/FileUpload';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FILE_SIZE, PDF_DOC_FORMATS } from '../../../constants/attachments';
import logo from '../../../assets/GatewayLogo/image.png';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../Auth/authSlice';
import toast from 'react-hot-toast';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import axios from 'axios';

const ReferralForm = ({ handleNavigateBack, jobId }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector(selectCurrentUser);
  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(3, 'First name must be at least 3 characters')
      .max(25, 'First name must be at most 25 characters')
      .required('First name is required'),
    middle_name: Yup.string()
      .min(1, 'Middle name must be at least 1 character')
      .max(25, 'Middle name must be at most 25 characters')
      .required('Middle name is required'),
    last_name: Yup.string()
      .min(3, 'Last name must be at least 3 characters')
      .max(25, 'Last name must be at most 25 characters')
      .required('Last name is required'),
    email: Yup.string()
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
      .required('Email is required'),
    mobile: Yup.string()
      .matches(/^\+?[1-9]\d{1,14}$/, 'Invalid phone number format')
      .required('Phone number is required'),
    // attachment: Yup.array()
    //   .of(
    //     Yup.mixed()
    //       .required('attachment is required')
    //       .test('fileSize', 'File is too large', (value) => value && value.size <= FILE_SIZE)
    //       .test('format', 'File should be PDF or DOC', (value) => value && PDF_DOC_FORMATS.includes(value.type))
    //   )
    //   .min(1, 'At least one file is required')
    //   .max(1, 'Only one file is allowed'),
    attachment: Yup.mixed()
      .test('fileRequired', 'File is required', (value) => {
        return value && value.length > 0;
      })
      .test('fileSize', 'File size should be less than 5MB', (value) => {
        return value && value[0] && value[0].size <= FILE_SIZE;
      })
      .test('fileFormat', 'File should be PDF or DOC', (value) => {
        return value && value[0] && PDF_DOC_FORMATS.includes(value[0].type);
      }),
  });

  const formik = useFormik({
    initialValues: {
      first_name: '',
      middle_name: '',
      last_name: '',
      email: '',
      mobile: '',
      attachment: [],
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append('job_id', jobId);
      formData.append('first_name', values.first_name);
      formData.append('middle_name', values.middle_name);
      formData.append('last_name', values.last_name);
      formData.append('email', values.email);
      formData.append('mobile', values.mobile);
      if (values.attachment.length > 0) {
        formData.append('resume', values.attachment[0]);
      }

      if (user.username == 'admin' && user.password == 'linkway') {
        const responsePostReferralData = await axios.post(
          `https://connectapi.thegatewaycorp.com/api/v1/referral-viewset/create-prospect/`,
          formData,
          {
            headers: {
              Authorization: `a020e9dc3bbf6bcc67f781952e634a475857a542`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        console.log(responsePostReferralData);
        if (responsePostReferralData.data.status == 200 || responsePostReferralData.data.status == 201) {
          toast.success(responsePostReferralData.data.message);
        } else {
          toast.error(responsePostReferralData.data.message);
        }
      } else {
        const responseLogin = await axios.post(`https://connectapi.thegatewaycorp.com/api/v1/referral-login/`, {
          username: user.username,
          password: user.password,
        });
        console.log('referraltoken', responseLogin);
        const referraltoken = responseLogin.data.data.token;
        const responsePostReferralData = await axios.post(
          `https://connectapi.thegatewaycorp.com/api/v1/referral-viewset/create-prospect/`,
          formData,
          {
            headers: {
              Authorization: `${referraltoken}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (responsePostReferralData.data.status == 200 || responsePostReferralData.data.status == 201) {
          toast.success(responsePostReferralData.data.message);
        } else {
          toast.error(responsePostReferralData.data.message);
        }
      }

      resetForm();
    },
  });

  const handleFileChange = (event) => {
    const files = Array.from(event.currentTarget.files);
    // console.log('files', files);
    // if (files[0]?.size > 1 * 1024 * 1024) {
    //   toast.error('File is too large', {
    //     duration: 5000,
    //   });
    //   alert('File is too large');
    //   console.log('File is too large');
    //   return;
    // }
    formik.setFieldTouched('attachment', true);
    formik.setFieldValue('attachment', files);
  };
return (
  <Grid sx={{ width: '100%', height: '100vh', backgroundColor: 'white' }}>
    {isSm && (
      <NavbarLayout handleNavigate={handleNavigateBack}>
        <Grid item display="flex" justifyContent="start" alignItems="center">
          <Newspaper sx={variants.icon.active} />
          <Typography component="div" ml={1} sx={{ fontSize: variants.BODY }}>
            Referral Form
            <Typography sx={{ fontSize: variants.TINY }}>
              Recommend a qualified candidate.
            </Typography>
          </Typography>
        </Grid>
      </NavbarLayout>
    )}

    {/* Full height container with scrollable area */}
    <Grid
      sx={{
        width: '100%',
        height: `calc(100vh - 100px)`,
        border: 1,
        borderColor: 'divider',
        borderRadius: variants.boxRadius.MAIN,
        mt: 1,
        overflowY: 'auto', // ✅ SCROLLS ENTIRE FORM
        // maxHeight:'calc(100vh - 240px)',
        p: 2,
      }}
    >
      <Box mb={2}>
        <img src={logo} alt="Logo" width={200} height={70} />
      </Box>

      <form onSubmit={formik.handleSubmit}>
        <Grid
          container
          direction="column"
          alignItems="center"
          gap={2}
          sx={{ backgroundColor: 'white' }}
        >
          <Grid item sx={{ width: '90%' }}>
            <TextField
              fullWidth
              label="First Name *"
              name="first_name"
              type="text"
              variant="outlined"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.first_name && !!formik.errors.first_name}
              helperText={formik.touched.first_name && formik.errors.first_name}
              margin="normal"
              InputLabelProps={{ style: { fontSize: variants.fontSize.SUB_HEADING } }}
              InputProps={{
                placeholder: 'Enter First Name here...',
                style: { fontSize: variants.fontSize.SUB_HEADING },
              }}
            />

            <TextField
              fullWidth
              label="Middle Name *"
              name="middle_name"
              type="text"
              variant="outlined"
              value={formik.values.middle_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.middle_name && !!formik.errors.middle_name}
              helperText={formik.touched.middle_name && formik.errors.middle_name}
              margin="normal"
              InputLabelProps={{ style: { fontSize: variants.fontSize.SUB_HEADING } }}
              InputProps={{
                placeholder: 'Enter Middle Name here...',
                style: { fontSize: variants.fontSize.SUB_HEADING },
              }}
            />

            <TextField
              fullWidth
              label="Last Name *"
              name="last_name"
              type="text"
              variant="outlined"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.last_name && !!formik.errors.last_name}
              helperText={formik.touched.last_name && formik.errors.last_name}
              margin="normal"
              InputLabelProps={{ style: { fontSize: variants.fontSize.SUB_HEADING } }}
              InputProps={{
                placeholder: 'Enter Last Name here...',
                style: { fontSize: variants.fontSize.SUB_HEADING },
              }}
            />

            <TextField
              fullWidth
              label="Email *"
              name="email"
              type="email"
              variant="outlined"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && !!formik.errors.email}
              helperText={formik.touched.email && formik.errors.email}
              margin="normal"
              InputLabelProps={{ style: { fontSize: variants.fontSize.SUB_HEADING } }}
              InputProps={{
                placeholder: 'Enter Email here...',
                style: { fontSize: variants.fontSize.SUB_HEADING },
              }}
            />

            <Box mt={2}>
              <PhoneInput
                country="in"
                value={formik.values.mobile}
                onChange={(value) => formik.setFieldValue('mobile', value)}
                inputProps={{ name: 'mobile', required: true }}
                inputStyle={{
                  width: '100%',
                  height: '3.3rem',
                  borderRadius: '5px',
                  border: formik.touched.mobile && formik.errors.mobile
                    ? '1px solid red'
                    : '1px solid #ccc',
                }}
                buttonStyle={{
                  borderRadius: '8px 0 0 8px',
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                }}
                autoFormat={true}
              />
              <Typography fontSize={12} ml={2} color="error">
                {formik.touched.mobile && formik.errors.mobile}
              </Typography>
            </Box>
          </Grid>

          <Box item sx={{ width: '90%' }}>
            <FileUpload
              handleFileChange={handleFileChange}
              formik={formik}
              name="attachment"
              buttonText="Resume"
              fullWidth={true}
              multiple={false}
              accept={
                'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text'
              }
            />
          </Box>

          <Box item sx={{ width: '90%' }}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ fontWeight: 'bold', borderRadius: '8px', fontSize: variants.fontSize.TEXT }}
            >
              Submit
            </Button>
          </Box>

          {!isSm && (
            <Box item sx={{ width: '90%' }}>
              <Button
                fullWidth
                onClick={handleNavigateBack}
                variant="contained"
                sx={{ fontWeight: 'bold', borderRadius: '8px', fontSize: variants.fontSize.TEXT }}
              >
                Cancel
              </Button>
            </Box>
          )}
        </Grid>
      </form>
    </Grid>
  </Grid>
);

};

export default ReferralForm;
